import { Route } from '@angular/router';
import { PaymentLayoutComponent } from '@webapp/payment-link/ui/pages/payment-layout/payment-layout.component';
import { PaymentLinkPageComponent } from './ui/pages/payment-link-page/payment-link-page.component';
import { PaymentLinkSuccessPageComponent } from './ui/pages/payment-link-success-page/payment-link-success-page.component';
import { GlobalErrorComponent } from '@webapp/core/ui/components/global-error/global-error-page.component';
export const appRoutes: Route[] = [
  {
    path: 'cotizacion/:id',
    component: PaymentLayoutComponent,
    children: [
      {
        path: '',
        component: PaymentLinkPageComponent,
      },
    ],
  },

  {
    path: 'pago-exitoso',
    component: PaymentLayoutComponent,
    children: [
      {
        path: '',
        component: PaymentLinkSuccessPageComponent,
      },
    ],
  },
  {
    path: 'error',
    component: PaymentLayoutComponent,
    children: [
      {
        path: '',
        component: GlobalErrorComponent,
      },
    ],
  },
];
